import axios from "axios";

// Determine backend URL with safe fallback to same-origin.
// This protects against the production secret REACT_APP_BACKEND_URL
// pointing to the wrong host (e.g. an old emergent.host URL).
function resolveBackend() {
  const env = process.env.REACT_APP_BACKEND_URL;
  if (typeof window !== "undefined") {
    const origin = window.location.origin;
    // If env is missing OR points to a different host than the current page,
    // prefer same-origin (relative). This keeps the live custom domain
    // working even when the deployment secret is outdated.
    if (!env) return origin;
    try {
      const envHost = new URL(env).host;
      const curHost = window.location.host;
      // Production custom domain — always use itself
      if (curHost === "bilioneurobabies.com" || curHost === "www.bilioneurobabies.com") {
        return origin;
      }
      // If env points to a stale emergent.host, prefer current origin
      if (envHost.endsWith(".emergent.host") && curHost !== envHost) {
        return origin;
      }
      return env;
    } catch {
      return origin;
    }
  }
  return env || "";
}

export const BACKEND_URL = resolveBackend();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

export const adminApi = () => {
  // Use sessionStorage so the admin token clears when the browser is closed
  // (narrower XSS-token-persistence window than localStorage)
  const token = sessionStorage.getItem("beb_admin_token");
  return axios.create({
    baseURL: API,
    headers: { "X-Admin-Token": token || "" },
  });
};

export const CONTACT = {
  phone: "+306944909006",
  whatsapp: "306944909006",
  viber: "306944909006",
  display: "+30 6944 909 006",
  email: "bilioneurobabies@gmail.com",
};
